import { render, staticRenderFns } from "./ClinicTopPlacements.vue?vue&type=template&id=61ac0866&scoped=true&"
import script from "./ClinicTopPlacements.vue?vue&type=script&lang=js&"
export * from "./ClinicTopPlacements.vue?vue&type=script&lang=js&"
import style0 from "./ClinicTopPlacements.vue?vue&type=style&index=0&id=61ac0866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac0866",
  null
  
)

export default component.exports